<template>
  <div class="default-payment-card-container">
    <default-section title="Meio de pagamento">
      <template v-slot:content>
        <div class="content">
          <div class="value-output">
            Valor total

            <div class="value">
              {{ grandValueReal }}
            </div>
          </div>
        </div>
      </template>
    </default-section>
  </div>
</template>

<script>
  import DefaultSection from '@/components/base/DefaultSection';

  export default {
    data() {
      return {
        grandValueReal: 0
      };
    },

    components: {
      'default-section': DefaultSection
    },

    props: {
      value: {
        type: Number,
        default: 0
      }
    },

    watch: {
      value(value) {
        this.grandValueReal = this.parseAmount(value);
      }
    },

    mounted() {
      this.grandValueReal = this.parseAmount(this.value);
    },

    methods: {
      parseAmount(value) {
        return this.$utils.formatBrlAmount(value);
      }
    }
  };
</script>

<style lang="scss">
  .default-payment-card-container {
    .content {
      margin-top: 1.5rem;
      display: flex;

      .value-output {
        font-size: 14px;
        width: 100%;

        .value {
          padding: 1rem;
          max-width: 12rem;
          width: 100%;
          height: 48px;
          background: #dadada;
          border-radius: 0.5rem;
          margin-top: 0.5rem;
          font-weight: 600;
          font-size: 20px;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  @media (max-width: 520px) {
    .default-payment-card-container {
      .content {
        .value-output {
          font-size: 12px;
        }
      }
    }
  }
</style>